import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CustomerTypeProvider extends HttpRequest {
  findAll () {
    return this.get('/customer-type')
  }

  findAllType (config) {
    return this.get('/customer-type/type/all', undefined, config)
  }

  createGroup (payload) {
    return this.post('/customer-type', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/customer-type/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/customer-type/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/customer-type?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default CustomerTypeProvider
